import { uniqueId } from "lodash";
import { Coordinate } from "ol/coordinate";
import { FeatureFromGeojson } from "../Map/FeaturesStore";

export type GeometryType = "Point" | "MultiPoint" | "LineString" | "Polygon";

export type PointGeometry = {
  type: "Point";
  coordinates: Coordinate;
};

export type LineGeometry = {
  type: "MultiPoint" | "LineString";
  coordinates: Coordinate[];
};

export type PolygonGeometry = {
  type: "Polygon";
  coordinates: Coordinate[][];
};

export type MakeGeojsonShape = PointGeometry | LineGeometry | PolygonGeometry;

type MakeGeojsonShapeArgs = MakeGeojsonShape;

/**
 * 그리기 도구가 넘기는 도형 식별 속성 — 제목·이슈 유형·심각도 같은 사용자 입력은
 * 호출부(생성 폼)가 채우므로 여기서 기본값을 만들지 않는다.
 */
export interface DrawnShapeProperties {
  type: string;
  original_type: string;
  [key: string]: unknown;
}

export function makeGeojsonShape(
  { type, coordinates }: MakeGeojsonShapeArgs,
  properties: DrawnShapeProperties
): FeatureFromGeojson {
  return {
    type: "Feature",
    id: uniqueId("drawing-"),
    geometry: { type, coordinates } as MakeGeojsonShape,
    properties,
  };
}
